import React, {ReactElement, useContext} from 'react';
import {BASE_PATH, CONTACT_EMAIL, CONTACT_NAME} from '../config/constants';
import {UserContext} from '../context/userContext';
import logo from '../vendor/images/FAA-logo.svg';


export default function HeaderComponent(): ReactElement {

    const { user, signoutUser } = useContext(UserContext);

    return (
        <div>

            {/*top blue bar*/}
            <div className='devkit-top-bar'>
                <img src={logo} alt='FAA logo' style={{ height: 60, marginRight: 8, verticalAlign: 'middle' }} />
                <span className='devkit-title-separator'>|</span>
                <span className='devkit-app-title-inline'>
                    <a href={BASE_PATH + '/workspace'}>Integrated Safety Assessment Model</a>
                </span>

                {/*User info and sign out - right side of blue bar*/}
                <div className='devkit-top-bar-right'>
                    {user ? (
                        <>
                            <span className='devkit-top-bar-welcome'>
                                Welcome, {user.firstName + ' ' + user.lastName}
                            </span>
                            <span className='devkit-title-separator'>|</span>
                            <a href={BASE_PATH + '/workspace'} className='devkit-top-bar-link'>
                                Workspace
                            </a>
                            <span className='devkit-title-separator'>|</span>
                            <div className='devkit-top-bar-contact-wrapper'>
                                <span className='devkit-top-bar-link devkit-top-bar-contact-btn'>
                                    Contact
                                </span>
                                <div className='devkit-top-bar-contact-dropdown'>
                                    <p>
                                        For more information on the ISAM project and to request access and/or support, please contact:
                                    </p>
                                    <div>
                                        <span className='devkit-contact-label'>Project Lead:</span>
                                        <span className='devkit-contact-value'>{CONTACT_NAME}</span>
                                    </div>
                                    <div>
                                        <span className='devkit-contact-label'>Email:</span>
                                        <span className='devkit-contact-value'>{CONTACT_EMAIL}</span>
                                    </div>
                                </div>
                            </div>
                            <span className='devkit-title-separator'>|</span>
                            <a href='signout' onClick={signoutUser} className='devkit-top-bar-link'>
                                Sign Out
                            </a>
                        </>
                    ) : (
                        <a href={BASE_PATH + '/signin'} className='devkit-top-bar-link'>
                            Sign In
                        </a>
                    )}
                </div>
            </div>
        </div>
    );

}